import { FC } from 'react';
import styled from 'styled-components';

const StyledRailItem = styled.li<{ $disableHover: boolean; $compact: boolean }>`
  cursor: pointer;
  padding: ${({ theme, $compact }) => ($compact ? theme.spacing.small : theme.spacing.default)};
  gap: 10px;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.sectionHeader};
  border-radius: ${({ theme }) => theme.radius.small};

  svg {
    color: grey;
  }

  &:hover {
    color: ${({ theme }) => theme?.palette?.text};
    background-color: ${({ theme, $disableHover }) => ($disableHover ? 'none' : theme?.palette?.listHoverBackground || 'lightgray')};
  }

  &.active {
    background-color: ${({ theme }) => theme?.palette?.accent};
  }

  &.completed {
    svg {
      color: green;
    }
  }

  .error-color {
    color: red;
  }
`;

interface NgRailItemProps {
  item?: ProjectSideNavItem;
  title?: string;
  disableHover?: boolean;
  className?: string;
  onClick?: () => void;
  compact?: boolean;
  children?: React.ReactNode;
}

export const NgRailItem: FC<NgRailItemProps> = ({
  item,
  disableHover = false,
  onClick,
  className,
  title,
  compact = false,
  children,
}) => {
  return (
    <StyledRailItem $disableHover={disableHover} $compact={compact} className={className} onClick={onClick}>
      {title && <span>{title}</span>}

      {children}
    </StyledRailItem>
  );
};
